import * as React from 'react';
import { createRoot } from 'react-dom/client';

// Configures the API client before any component can issue a request.
import '@/lib/api-setup';
import '@/index.css';

import { App } from '@/app';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element is missing from index.html');
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
